module.exports = __webpack_public_path__ + "static/test3-d8daf17b995679f1780296421e686cb0.jpg";